var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    transform: "matrix(1 0 0 -1 0 24)",
    fill: "#FFE9ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.08 14.1528C17.9448 14.306 17.7786 14.4286 17.5924 14.5126C17.4062 14.5966 17.2043 14.64 17 14.64H13.64V15.6C13.64 16.2365 13.3871 16.847 12.9371 17.2971C12.487 17.7471 11.8765 18 11.24 18C11.1508 18.0001 11.0634 17.9753 10.9875 17.9284C10.9116 17.8816 10.8503 17.8145 10.8104 17.7348L8.5436 13.2H5.96C5.70539 13.2 5.46121 13.0989 5.28118 12.9188C5.10114 12.7388 5 12.4946 5 12.24V6.96C5 6.70539 5.10114 6.46121 5.28118 6.28118C5.46121 6.10114 5.70539 6 5.96 6H16.28C16.6308 5.99988 16.9696 6.12783 17.2328 6.35984C17.4959 6.59184 17.6653 6.91193 17.7092 7.26L18.4292 13.02C18.4547 13.2228 18.4368 13.4287 18.3766 13.624C18.3164 13.8193 18.2153 13.9996 18.08 14.1528ZM5.96 12.24H8.36V6.96H5.96V12.24Z",
    fill: "#EF1941"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.bf13dbb337a78efe8e47fbbff13921ad.svg";
export { ForwardRef as ReactComponent };